import { translate } from '../../utils/translate';
import { Body, Inner, Label, Outer } from './Callout.styles';

type CalloutProps = {
  labelTx: string;
  bodyTx: string;
  className?: string;
};

export const Callout = ({ labelTx, bodyTx, className }: CalloutProps) => (
  <Outer className={className} role="callout">
    <Inner>
      <Label>{translate(labelTx)}</Label>
      <Body>{translate(bodyTx)}</Body>
    </Inner>
  </Outer>
);
